import { render, staticRenderFns } from "./TaskCategoryTable.vue?vue&type=template&id=1db4b4d0&"
import script from "./TaskCategoryTable.vue?vue&type=script&lang=js&"
export * from "./TaskCategoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports